<template>
  <div class="contain">
    <div v-for="(item, index) in articleInfo" :key="index">
      <div v-if="item.type == 'text'" v-html="item.value" style="white-space: pre-wrap;" class="texts"></div>
      <div v-if="item.type == 'image'">
        <img draggable="false" style="width: 100%;display: block;" :src="url + item.file" alt="image" />
      </div>
    </div>
  </div>
</template>

<script>
import { AUTHORIZE } from "../config/config";

import { getAgree } from '../api/agreement'
import { getToken, getUser } from "../api/user";
export default {
  name: 'agreement',
  data() {
    return {
      articleInfo: null,
      title: '',
      url: process.env.VUE_APP_BASE_IMG,
      isInWeChat: /MicroMessenger/i.test(navigator.userAgent),
    }
  },
  created() {
    this.title = this.$route.query.name
    this.getAgree(this.title)

    if (this.title === '授权页' && !this.$route.query.code) {
      this.handleAuthorize()
      return
    }

    this.getToken()
  },
  methods: {
    /** 获取 ToKen */
    getToken() {
      getToken({ code: this.$route.query.code }).then(res => {
        console.log(res.data.data.token, "=> token");
        localStorage.removeItem("gjz_Token")
        localStorage.setItem("gjz_Token", res.data.data.token)
        this.getUser()
      })
    },

    /** 获取用户信息 */
    getUser() {
      getUser().then(res => {
        console.log(res.data.data, "=> getUser");
      })
    },

    /** 发起微信授权申请 */
    handleAuthorize() {
      window.location.href = AUTHORIZE()
    },

    async getAgree(title) {
      try {
        const { data } = await getAgree(title)
        this.articleInfo = JSON.parse(data.data.content)
      } catch (e) {

      }
    }
  }
}
</script>

<style scoped>
@import '../style/rich.css';

.contain {
  background: #fff;
  width: 100%;
  padding: 10px;
  font-size: 60px !important;
  box-sizing: border-box;
}

img {
  user-select: auto;
  pointer-events: auto;
  -webkit-touch-callout: none;
  -moz-user-select: auto;
  -webkit-user-select: auto;
  -o-user-select: auto;
}
</style>